// extracted by mini-css-extract-plugin
module.exports = {"panel":"register__panel___3Jcuw","salutationSelect":"register__salutationSelect___2epJL"};